import { Category } from '@gripp/shared-logic';
import { StyleProp, StyleSheet } from 'react-native';
import { Chip } from 'react-native-paper';
import { Colors } from '../../themes';

type CategoryChipProps = {
  category: Category;
  onPress?: (categoryId: string) => Promise<void>;
  additionalStyle?: StyleProp<any>;
};

export const CategoryChip = (props: CategoryChipProps) => {
  const onPress = async (categoryId: string) => {
    if (props.onPress) {
      await props.onPress(categoryId);
    }
  };

  const chipStyle = props.additionalStyle
    ? [styles.chip, props.additionalStyle]
    : [styles.chip];

  return (
    <Chip
      onPress={async () => await onPress(props.category.id)}
      textStyle={styles.chipText}
      style={chipStyle}
      ellipsizeMode="tail"
    >
      {props.category.name}
    </Chip>
  );
};

const styles = StyleSheet.create({
  chip: {
    backgroundColor: Colors.primaryGrayBackground,
  },
  chipText: {
    lineHeight: 14,
    fontWeight: '400',
    color: Colors.black,
    paddingVertical: 1,
    marginLeft: 10,
    marginRight: 10,
    marginTop: 5,
    marginBottom: 5,
  },
});

export const CategoryChipTextStyle = styles.chipText;
export const CategoryChipStyle = styles.chip;
